<template>
  <div class="mb-4">
    <MDBBtnGroup aria-label="Basic example" class="mx-2">
      <MDBBtn
        color="primary"
        :class="{ active: isActive['Light'] }"
        @click="filterActive('Light')"
        >Light</MDBBtn
      >
      <MDBBtn
        color="primary"
        :class="{ active: isActive['Flying'] }"
        @click="filterActive('Flying')"
        >Flying</MDBBtn
      >
      <MDBBtn
        color="primary"
        :class="{ active: isActive['Heavy'] }"
        @click="filterActive('Heavy')"
        >Heavy</MDBBtn
      >
    </MDBBtnGroup>
    <MDBBtnGroup aria-label="Basic example" class="mx-2">
      <MDBBtn
        color="success"
        :class="{ active: isActive['Attacker'] }"
        @click="filterActive('Attacker')"
        >Attackers</MDBBtn
      >
      <MDBBtn
        color="success"
        :class="{ active: isActive['Defender'] }"
        @click="filterActive('Defender')"
        >Defenders</MDBBtn
      >
      <MDBBtn
        color="success"
        :class="{ active: isActive['Supporter'] }"
        @click="filterActive('Supporter')"
        >Supporters</MDBBtn
      >
    </MDBBtnGroup>
    <MDBCheckbox
    tag="span"
    :btnCheck="true"
    labelClass="btn btn-danger"
    label="Show Unused"
    v-model="used"
  />
  </div>

  <div class="mb-4">
    <MDBInput label="Type Name to Search" v-model="inputName" inputGroup>
      <MDBBtn color="danger"> Reset </MDBBtn></MDBInput
    >
  </div>

  <MDBRow>
    <MDBCol v-for="enemy in filteredEnemy" :key="enemy[0]" col="8" sm="6" md="4" lg="3" xl="2">
      <MDBCard
        text="white"
        bg="dark"
        class="mb-3 click-card"
        @click="clickEnemy(enemy[0])"
      >
        <MDBCardImg
          :src="'images/profile/' + enemy[2] + '.png'"
          top
        />
        <MDBCardBody style="padding:0.5rem">
          <MDBCardText>{{ enemy[1] }}</MDBCardText>
        </MDBCardBody>
      </MDBCard>
    </MDBCol>
  </MDBRow>
  <enemy-tab :enemy="this.id" :lvl="this.lvl" @update="updateEvent"/>
</template>

<script>
// @ is an alias to /src
import EnemyTab from "../components/EnemyTab.vue";
// import { useStore } from "vuex";
import { ref } from "vue";
import {
  MDBCard,
  MDBCardBody,
  // MDBCardTitle,
  MDBCardText,
  MDBCardImg,
  MDBBtn,
  MDBBtnGroup,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBCheckbox,
} from "mdb-vue-ui-kit";
export default {
  components: {
    EnemyTab,
    MDBCard,
    MDBCardBody,
    // MDBCardTitle,
    MDBCardText,
    MDBCardImg,
    MDBBtn,
    MDBBtnGroup,
    MDBRow,
    MDBCol,
    MDBInput,
    MDBCheckbox,
  },
  name: "Enemy",
  data() {
    return {
      id: this.$route.params.id,
      isActive: {
        Light: true,
        Flying: true,
        Heavy: true,
        Attacker: true,
        Defender: true,
        Supporter: true,
      },
    };
  },
  computed: {
    lvl() {
      if (this.$route.query.lvl) {
        return this.$route.query.lvl;
      } else return 1;
    },
    enemies() {
      var enemylist = this.$store.getters.getEnemies;
      var enemies = [];
      var dupe = [];
      for (var key in enemylist) {
        var val = enemylist[key];
        if (!dupe.includes(val["name"])) {
          if (this.filterUsed(val["used"])) {
            dupe.push(val["name"]);
            enemies.push([
              key,
              val["name"],
              val["img"],
              val["type"],
              val["role"],
              val["used"]
            ]);
          }
        }
      }
      return enemies;
    },
    filteredEnemy() {
      return this.enemies.filter((e) =>
        e[1].toLowerCase().includes(this.inputName.toLowerCase())
      ).filter((e) => this.isActive[e[3]] & this.isActive[e[4]]);
    },
  },
  methods: {
    clickEnemy(name) {
      this.id = name;
      // this.$router.push("/enemy/" + name);
    },
    filterActive(id) {
      this.isActive[id] = !this.isActive[id];
    },
    filterUsed(used) {
      if (this.used == false) {
        return Object.keys(used).length > 0
      }
      return true
    },
    updateEvent(e) {
      if (e == false) {
        this.id = "";
        this.$router.push("/enemy/")
      }
    }
  },
  async setup() {
    // const store = useStore();
    // await store.dispatch("init");
    const inputName = ref("");
    const used = ref(false);
    return {
      inputName, used
    };
  },
  created() {
    document.title = "Enemy List"
  },
};
</script>
<style scoped>
.row-cols-xl-7 > * {
  flex: 0 0 auto;
  width: 14.2857142857%;
}
</style>
